import React from "react";
import Alert from "@amzn/meridian/alert"
import {AlertProps} from "src/interfaces/props/CommonProps";

export class InformalAlert extends React.Component<AlertProps> {

    constructor(props: AlertProps) {
        super(props);
    }

    render() {
        return (
            <Alert type="informational" size="large" autoFocus={true} onClose={this.props.onClose}> {this.props.text} </Alert>
        );
    }
}

export default InformalAlert;